import { render, staticRenderFns } from "./ClassFormModal.vue?vue&type=template&id=43a08a80&scoped=true"
import script from "./ClassFormModal.vue?vue&type=script&lang=js"
export * from "./ClassFormModal.vue?vue&type=script&lang=js"
import style0 from "./ClassFormModal.vue?vue&type=style&index=0&id=43a08a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a08a80",
  null
  
)

export default component.exports